import React, { useState, useEffect } from 'react';
import DatePicker from '../DatePicker';
import moment from 'moment';

// Utils
import { formatCurrency, useEscapeClose } from '../../../utils/SamuiUtils';
import { useModalKeyboardNavigation, scrollToRow, getRowStyle, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';
import { formatDate } from '../../../utils/DateUtils';

const QtModal = ({ showQtModal, handleQtClose, qtDataList, onRowSelectQt }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filteredQtDataList, setFilteredQtDataList] = useState([]);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);

    useEscapeClose(showQtModal, handleQtClose);

    // เพิ่ม keyboard navigation
    useModalKeyboardNavigation(
        showQtModal,
        filteredQtDataList,
        selectedRowIndex,
        setSelectedRowIndex,
        onRowSelectQt,
        handleQtClose
    );

    // ฟิลเตอร์ข้อมูลเมื่อ searchTerm หรือ qtDataList เปลี่ยนแปลง
    useEffect(() => {
        setFilteredQtDataList(
            qtDataList.filter(qt => {
                const isSearchMatch = qt.Doc_No.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    qt.AR_Name.toLowerCase().includes(searchTerm.toLowerCase());

                const isDateInRange = !startDate || !endDate ||
                    moment(qt.Doc_Date).isBetween(startDate, endDate, 'day', '[]');

                return isSearchMatch && isDateInRange;
            }
            )
        );
    }, [searchTerm, qtDataList, startDate, endDate]);

    useEffect(() => {
        if (showQtModal) {
            setSearchTerm('');
            setSelectedRowIndex(0); // Reset selected row when modal opens
            setStartDate(moment(Math.min(...qtDataList.map(qt => moment(qt.Doc_Date || moment())))));
            setEndDate(moment(Math.max(...qtDataList.map(qt => moment(qt.Doc_Date || moment())))));
        }
    }, [showQtModal]);

    return (
        <>
            {/* Modal */}
            <div className={`modal ${showQtModal ? 'show' : ''}`} style={{ display: showQtModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อใบเสนอราคา</h5>
                            <button type="button" className="close" onClick={handleQtClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-4">
                                    <div className="form-group">
                                        <input
                                            style={{ width: '100%' }}
                                            type="text"
                                            className="form-control"
                                            placeholder="ค้นหาเลขที่เอกสาร หรือ ชื่อลูกค้า"
                                            value={searchTerm || ''}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <DatePicker
                                            label="วันที่เริ่มต้น"
                                            name="startDate"
                                            value={startDate}
                                            onChange={(date) => setStartDate(moment(date).format('YYYY-MM-DD'))}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <DatePicker
                                            label="วันที่สิ้นสุด"
                                            name="endDate"
                                            value={endDate}
                                            onChange={(date) => setEndDate(moment(date).format('YYYY-MM-DD'))}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '15%' }}>เลขที่เอกสาร (QT)</th>
                                            <th className="text-center" style={{ width: '10%' }}>วันที่เอกสาร</th>
                                            <th className="text-center" style={{ width: '30%' }}>ชื่อลูกค้า</th>
                                            <th className="text-center" style={{ width: '35%' }}>รายละเอียดเอกสาร</th>
                                            <th className="text-center" style={{ width: '10%' }}>ราคารวม</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredQtDataList && filteredQtDataList.length > 0 ? (
                                            filteredQtDataList.map((qt, index) => (
                                                <tr key={qt.Doc_Id || index + 1}
                                                    onClick={() => {
                                                        setSelectedRowIndex(index);
                                                        onRowSelectQt(qt);
                                                    }}
                                                    style={getRowStyle(index, selectedRowIndex)}>
                                                    <td className="text-center">{qt.Doc_No}</td>
                                                    <td className="text-center">{formatDate(qt.Doc_Date)}</td>
                                                    <td className="text-left">{qt.AR_Name}</td>
                                                    <td className="text-left">{qt.Doc_Remark1}</td>
                                                    <td className="text-end">{formatCurrency(qt.NetTotal)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={handleQtClose}>
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Overlay */}
            {showQtModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default QtModal;